import React, { FC } from 'react';
import RoomsAndGuests from '../../molecules/roomsAndGuests/index';
import SpecialRates from '../../molecules/specialRates/index';
import UsePoints from '../../molecules/usePoints/usePoints';
import { SearchDesktopSecondary } from './searchSecondaryBar.styles';
import clsx from 'clsx';

const SearchSecondaryBar: FC<{
  isPublishUserSelection: boolean;
  isSearchPage?: boolean;
  isUserInteractWithComp?: boolean;
  isADFPage?: boolean;
}> = ({ isPublishUserSelection = false, isSearchPage = false, isADFPage = false }) => (
  <SearchDesktopSecondary
    className={clsx(
      'container',
      'search-secondary',
      isSearchPage ? 'search-bar' : '',
      isADFPage ? 'adf-search-bar' : ''
    )}
  >
    {/* flag added to hide Roomsand Guests incase of ADF Page */}

    {!isADFPage && <RoomsAndGuests isPublishUserSelection={isPublishUserSelection} isSearchPage={isSearchPage} />}
    <SpecialRates isSearchPage={isSearchPage} isADFPage={isADFPage} />
    <UsePoints value={'true'} />
  </SearchDesktopSecondary>
);

export default SearchSecondaryBar;
